import React from 'react';

const BuilderIllustration = ({ className = "" }) => (
  <svg className={className} width="200" height="180" viewBox="0 0 200 180" fill="none">
    {/* Drag icon */}
    <rect x="20" y="30" width="60" height="40" rx="8" stroke="currentColor" strokeWidth="3" fill="none"/>
    <circle cx="35" cy="45" r="4" fill="currentColor"/>
    <line x1="45" y1="42" x2="65" y2="42" stroke="currentColor" strokeWidth="2"/>
    <line x1="45" y1="50" x2="65" y2="50" stroke="currentColor" strokeWidth="2"/>
    <line x1="45" y1="58" x2="58" y2="58" stroke="currentColor" strokeWidth="2"/>
    
    {/* Arrow */}
    <path d="M90 50 L 110 50" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="5,5"/>
    <path d="M105 45 L 110 50 L 105 55" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    
    {/* Drop target */}
    <rect x="120" y="20" width="60" height="60" rx="8" stroke="#00FFC6" strokeWidth="3" fill="none" strokeDasharray="8,4"/>
    <text x="150" y="55" textAnchor="middle" fontSize="24" fill="#00FFC6">+</text>
    
    {/* Bottom elements */}
    <rect x="20" y="100" width="160" height="15" rx="4" fill="currentColor" opacity="0.2"/>
    <rect x="20" y="125" width="120" height="15" rx="4" fill="currentColor" opacity="0.2"/>
    <rect x="20" y="150" width="100" height="15" rx="4" fill="#0066FF" opacity="0.6"/>
  </svg>
);

export default BuilderIllustration;